<div class="card">
    <div class="card-body">
        <h5 class="card-title">{{ 'export.risks.cardTitle' | transloco }}</h5>
        <h6 class="card-subtitle mb-2 text-muted">{{ 'export.selectExportTypeBelow' | transloco }}</h6>

        <hr />

        <button class="btn btn-default me-2 mb-2" (click)="download(ExportType.Risks)">
            {{ 'export.risks.risksButton' | transloco }}
        </button>
        @if (permService.permissions.HasRiskControlExportAccess) {
            <button class="btn btn-default me-2 mb-2" (click)="download(ExportType.RisksControls)">
                {{ 'export.risks.risksControlsButton' | transloco }}
            </button>
            <button
                class="btn btn-default me-2 mb-2"
                (click)="download(ExportType.RiskControlMois)"
            >
                {{ 'export.risks.risksControlsMoisButton' | transloco }}
            </button>
            <button
                class="btn btn-default me-2 mb-2"
                (click)="exportRiskAssessmentPerOrganization()"
            >
                {{ 'export.risks.riskAssessmentButton' | transloco }}
            </button>
        }
        @if (permService.permissions.IsDeveloperAdmin) {
            <hr />

            <mat-checkbox color="primary" name="includeArchivedLinks" [(ngModel)]="includearchivedlinks"
                >{{ 'export.includeArchivedLinksCheckbox' | transloco }}</mat-checkbox
            >
            <hr />

            <button
            class="btn btn-default me-2 mb-2"
            (click)="downloadRiskForImport()"
            >
                {{ 'export.risks.riskExportForImportButton' | transloco }}
            </button>
        }
    </div>
</div>
